import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { opsEstimateEndpoints } from '@/lib/api/endpoints';
import { estimateKeys, jobKeys } from '@/lib/queryKeys';
import type { CreateJobDto, Job } from '@/types/job';

export interface ConvertToJobVariables {
  estimateId: string;
  jobDraft: CreateJobDto;
}

/**
 * Submits the reviewed New Job draft through the estimate conversion
 * orchestrator. The estimate remains APPROVED until this mutation succeeds.
 */
export function useConvertToJob() {
  const queryClient = useQueryClient();

  return useApiMutation<Job, ConvertToJobVariables>({
    mutationFn: ({ estimateId, jobDraft }) =>
      apiPost<Job>(operationsClient, opsEstimateEndpoints.convertToJob(estimateId), {
        jobDraft,
      }),
    onSuccess: (_data, { estimateId }) => {
      void queryClient.invalidateQueries({ queryKey: estimateKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: estimateKeys.detail(estimateId) });
      void queryClient.invalidateQueries({ queryKey: jobKeys.lists() });
      toast.success('Estimate converted to job');
    },
  });
}
